exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".user-verification-wrapper[data-v-94bd735a]{min-height:calc(130vh - 60px)}.tips-content[data-v-94bd735a]{margin-left:20px;margin-bottom:20px;color:red;font-size:14px;line-height:28px}.form-bezel[data-v-94bd735a]{padding-left:20px;display:flex;flex-direction:row}.name-input[data-v-94bd735a]{width:200px}.button-export[data-v-94bd735a]{margin-left:auto;margin-right:20px;height:36px}.face-image[data-v-94bd735a]{margin-top:8px;width:40px;height:40px}.edit-form .el-form-item div[data-v-94bd735a]{display:flex}.edit-form .el-select[data-v-94bd735a]{flex:1}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-rewriter.js?id=data-v-94bd735a&scoped=true!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/views/UserManage/UserManage/UserVerification.vue
// module id = 607
// module chunks = 0